const FireMembership = ({ className = '' }) => (
  <svg
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={`stroke-green-800 w-3 ${className}`}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.49807 3.53971L4.6002 0.830887L6.86654 3.75133L8.33297 1.86162L9.50193 3.36794C10.2531 4.33587 10.6659 5.56866 10.6659 6.84349V7.01526C10.6659 8.3821 10.1744 9.69296 9.29932 10.6595C8.42429 11.626 7.23748 12.1689 5.99999 12.1689V12.1689C3.42306 12.1689 1.33405 9.86157 1.33405 7.01528V7.01528C1.33405 5.74044 1.74693 4.50765 2.49807 3.53971Z'
      strokeWidth='1.20715'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default FireMembership
